import { render, staticRenderFns } from "./TrashIcon.vue?vue&type=template&id=9b46e9c8"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b46e9c8')) {
      api.createRecord('9b46e9c8', component.options)
    } else {
      api.reload('9b46e9c8', component.options)
    }
    module.hot.accept("./TrashIcon.vue?vue&type=template&id=9b46e9c8", function () {
      api.rerender('9b46e9c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/TrashIcon.vue"
export default component.exports